import * as braze from '@braze/web-sdk'

const initBraze = () => {
  // If the Braze API key is set, initialize the SDK
  if (import.meta.env.VITE_BRAZE_API_KEY) {
    // Initialize Braze SDK
    // NOTE: This is done here because the SDK is not available in the index.tsx file.
    braze.initialize(import.meta.env.VITE_BRAZE_API_KEY, {
      baseUrl: 'https://sdk.iad-07.braze.com',
      enableLogging: !import.meta.env.PROD, // Set to false in production
    })
    braze.openSession()
  }
}

export default initBraze